var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.739 17.634V3.284q0-.546.36-.915T11.992 2t.893.37q.36.368.36.914v14.35l6.14-6.292q.375-.385.877-.37.502.017.877.402.345.385.36.899.015.513-.36.899l-8.27 8.475q-.188.193-.407.273-.22.08-.47.08t-.47-.08a1.1 1.1 0 0 1-.407-.273l-8.27-8.475a1.21 1.21 0 0 1-.345-.883q0-.53.345-.915.376-.385.892-.385.518 0 .893.385z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.9ebee16c22bf88311f1c864c10d3bc90.svg";
export { ForwardRef as ReactComponent };